export default "__VITE_ASSET__H_lZKt7v__"